"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWebPlayerIFrameURL = exports.createWebPlayerTransport = void 0;
function createWebPlayerTransport(config) {
    var transport = null;
    function getTransport() {
        var _a;
        transport = transport !== null && transport !== void 0 ? transport : config.createTransport({
            name: (_a = config.name) !== null && _a !== void 0 ? _a : 'webplayer',
            verbose: config.verbose,
        });
        return transport;
    }
    var origin = new URL(config.webPlayerURL).origin;
    var windowListener;
    var transportListener;
    return {
        addEventListener: function (type, listener) {
            var _a;
            if (!windowListener) {
                windowListener = function (event) {
                    if (event.origin === origin && typeof event.data === 'string') {
                        if (transport) {
                            transport.postMessage({
                                type: 'synthetic_event',
                                data: event.data,
                            });
                        }
                    }
                };
                (_a = config.window) === null || _a === void 0 ? void 0 : _a.addEventListener(type, windowListener);
            }
            if (!transportListener) {
                transportListener = function (event) {
                    var _a;
                    var message = event;
                    if (message.type === 'synthetic_event') {
                        (_a = config.ref.current) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify(message.data), origin);
                    }
                    else {
                        listener(message);
                    }
                };
            }
            getTransport().addEventListener(type, transportListener);
        },
        removeEventListener: function (type, _listener) {
            var _a;
            if (windowListener) {
                (_a = config.window) === null || _a === void 0 ? void 0 : _a.removeEventListener(type, windowListener);
                windowListener = undefined;
            }
            if (transportListener) {
                transport === null || transport === void 0 ? void 0 : transport.removeEventListener(type, transportListener);
                transportListener = undefined;
            }
        },
        postMessage: function (message) { return getTransport().postMessage(message); },
        // @ts-ignore: Dirty hack to allow snack web to to communicate with older web-players
        updateOrigin: function (newOrigin) { return (origin = newOrigin); },
    };
}
exports.createWebPlayerTransport = createWebPlayerTransport;
function getWebPlayerIFrameURL(webPlayerURL, sdkVersion, initialURL, verbose) {
    if (sdkVersion < '40.0.0' || typeof window === 'undefined') {
        return undefined;
    }
    return webPlayerURL.replace('%%SDK_VERSION%%', sdkVersion.split('.')[0]) + "/index.html?initialUrl=" + encodeURIComponent(initialURL) + "&origin=" + encodeURIComponent(window.location.origin) + "&verbose=" + verbose;
}
exports.getWebPlayerIFrameURL = getWebPlayerIFrameURL;
//# sourceMappingURL=webPlayer.js.map